import { useEffect } from 'react'

import CatchTheJoy from '../components/organisms/catch-the-joy'
import Celebration from '../components/organisms/celebration'
import IndexGallery from '../components/organisms/index-gallery'
import IntroText from '../components/organisms/intro-text'
import FilmStrip from '../components/organisms/film-strip'
import Timeline from '../components/organisms/timeline'
import { usePageTheme } from '../hooks/pageThemeHook'
import Layout from '../layouts/layout'
import Video from '../components/organisms/video'

const LandingPage = () => {
	const { setDarkTheme } = usePageTheme()

	useEffect(() => {
		setDarkTheme(false)
	}, [setDarkTheme])

	return (
		<Layout>
			<IntroText />
			<Celebration />
			<FilmStrip />
			<Timeline />
			<CatchTheJoy />
			<IndexGallery />
			{/* <Video /> */}
		</Layout>
	)
}

export default LandingPage
